<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div
	[ngClass]="['ag-overlay-loading-center', 'table-loading']"
	role="presentation"
>
	<globalictcc-spinner />

	<span class="message">Loading...</span>
</div>
